@if (pwaInstallAllowed) {
  <div class="bg-neutral-100 px-5 pb-9">
    @if (textWithButtonItem) {
      <app-push-text-button-atom
        [title]="textWithButtonItem.title"
        [text]="textWithButtonItem.text ?? ''"
        [textButton]="textWithButtonItem.button?.text ?? ''"
        [backgroundUrl]="textWithButtonItem.background ?? ''"
        [imgUrl]="textWithButtonItem.img ?? ''"
        (buttonClick)="installPwa()"
      ></app-push-text-button-atom>
    }
  </div>
}
